var map = {
	"./icon_menu_activity_manage.png": "S6UQ",
	"./icon_menu_advertising_manage.png": "vwxd",
	"./icon_menu_goods_manage.png": "uX2U",
	"./icon_menu_netBarAccount_manage.png": "J0tx",
	"./icon_menu_user_manage.png": "hunJ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bmvS";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/icon_menu_.*\.png$
// module id = bmvS
// module chunks = 1